var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery",attrs:{"data-columns":_vm.columnCount}},_vm._l((_vm.images),function(img,idx){return _c('span',{key:idx,staticClass:"gallery-item"},[_c('img',{attrs:{"src":img,"alt":""}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-482ba460","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subparts/KappGallery.vue
// module id = null
// module chunks = 